import { render, staticRenderFns } from "./EditContactPerson.vue?vue&type=template&id=7a963c8a&"
import script from "./EditContactPerson.vue?vue&type=script&lang=js&"
export * from "./EditContactPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports